import { CoreInitiativesBulkName } from './name';
import { coreInitiativesGetAsyncSlice } from '../get';
import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { patchInitiativesBulk } from '@api';

export const coreInitiativesBulkPatchAsyncSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [ coreInitiativesGetAsyncSlice.asyncActionCreators.repeatGetCoreInitiatives ]
	},
	name: CoreInitiativesBulkName,
	receive: false,
	request: true,
	requestHandler: patchInitiativesBulk
});
